import clsx from 'clsx';
import React, { FC } from 'react';

import Typography from '@/components/typography';
import { WaterModalContent } from '@/models/water';

interface IProps {
  tab: WaterModalContent;
  activeTabTitle?: string;
  setActiveTab: React.Dispatch<React.SetStateAction<WaterModalContent | null>>;
}

const WaterModalTab: FC<IProps> = ({
  tab,
  activeTabTitle = undefined,
  setActiveTab,
}) => (
  <div
    key={tab.title}
    className={clsx(
      'min-h-8 flex select-none px-2 py-1',
      tab.title === activeTabTitle ? 'bg-green-50 text-white' : ''
    )}
  >
    <button
      className="flex h-full w-full items-center"
      type="button"
      onClick={() => {
        setActiveTab(tab);
      }}
    >
      <Typography className="text-left" variant="h4">
        {tab.title}
      </Typography>
    </button>
  </div>
);

export default WaterModalTab;
